// Injected at build time by each app's Vite config (`define`), so the same UI
// package reports whatever the bundle it ships in was built from.
declare const __SAIP_VERSION__: string | undefined
declare const __SAIP_BUILD_DATE__: string | undefined

export interface BuildInfo {
  /** Version from the repo-root package.json. */
  version: string
  /** ISO timestamp of the build; null when nothing injected it (tests, tooling). */
  buildDate: string | null
}

export const buildInfo: BuildInfo = {
  version: typeof __SAIP_VERSION__ === 'string' ? __SAIP_VERSION__ : '0.0.0',
  buildDate: typeof __SAIP_BUILD_DATE__ === 'string' ? __SAIP_BUILD_DATE__ : null,
}

/** `11.09.2026 14:32` in the viewer's local time — or the raw value if unparsable. */
export function formatBuildDate(iso: string | null): string {
  if (!iso) return 'dev'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  const p = (n: number) => String(n).padStart(2, '0')
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`
}

/** One quiet line at the bottom of every screen: which build is this? */
export function BuildFooter({ info = buildInfo }: { info?: BuildInfo }) {
  return (
    <footer
      className="flex shrink-0 select-none items-center justify-center border-t border-neutral-100 px-3 py-1 text-[10px] leading-4 text-neutral-400"
      title={info.buildDate ?? undefined}
      data-testid="build-info"
    >
      Text Assistent v{info.version} · Build {formatBuildDate(info.buildDate)}
    </footer>
  )
}
